module.exports = __webpack_public_path__ + "static/img/pay_qrpay@3x.0173f2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pay_qrpay@3x.png
// module id = y9iF
// module chunks = 1